import React from "react";
import styles from "./CardBox.module.scss";

export default function CardBox({ title, children, className = "" }) {
  return (
    <div className={`${styles.cardBox} ${className}`}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.content}>{children}</div>
    </div>
  );
}